"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var TradeAllySectionTitle = function SectionTitleComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var _sliceData$primary = sliceData.primary,
      section_title_text = _sliceData$primary.section_title_text,
      title_alignment = _sliceData$primary.title_alignment;
  var sectionTitleClassName = (0, _classnames["default"])('content-page__section-title--trade-ally', {
    'content-page__section-title--left-align': title_alignment === 'Left',
    'content-page__section-title--center-align': title_alignment === 'Center',
    'content-page__section-title--right-align': title_alignment === 'Right'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: sectionTitleClassName
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "content-page__section-title-text--trade-ally"
  }, dataClient.textToMarkdown(section_title_text))));
};

TradeAllySectionTitle.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      section_title_text: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
    }).isRequired
  }).isRequired
};
var _default = TradeAllySectionTitle;
exports["default"] = _default;